import script from "./InstructionSendPulsePage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionSendPulsePage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionSendPulsePage.vue?vue&type=style&index=0&id=6f2050dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f2050dd"]])

export default __exports__